<script lang="ts">
	import { SOCIAL_MEDIA_LINKS } from '$lib/consts'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

	const links = SOCIAL_MEDIA_LINKS.map((link) => {
		return {
			...link,
			link: link.url[PUBLIC_WOLTAIR_WEB_CODE]
		}
	}).filter((link) => link.link)
</script>

<ul>
	{#each links as link}
		<li>
			<a href={link.link}>{link.name}</a>
		</li>
	{/each}
</ul>

<style lang="scss">
	ul {
		margin-top: 20px;

		li {
			list-style-type: none !important;
			line-height: 50px;
			padding: 0 10px;
			border-bottom: 1px solid #ccc;
			width: 350px;

			@media only screen and (max-width: 760px) {
				width: 100%;
			}

			@media (hover: hover) {
				&:hover {
					background: rgba(240, 240, 240, 0.5);
				}
			}

			a {
				display: block;
				width: 100%;
				font-size: 18px;
				height: 100%;
				color: #e20613;
			}
		}
	}
</style>
